import { Button, Box } from '@mui/material'
import Grid from '@mui/material/Grid2'
import React, { useEffect, useState } from 'react'
import { useApi } from '../../hooks/useApi'
import { MultipleReturns } from './MultipleReturns'
import { ReturnItemsSelection } from './ReturnItemsSelection'
import { SearchOrder } from './SearchOrder'
import { ReturnWorkOrderResponse, WorkOrderItems } from './types'
import { Status } from '../../hooks/useFetchState'
import { Loading } from '../UI'
import { CreateReturnHeader } from './CreateReturnHeader'
import { AsnReturnDto, SearchReturn } from './SearchReturn'
import { useCourier } from '../../hooks/useCourier'
import { ReturnBatchSelecion } from './ReturnBatchSelection'
import { useUser } from '../../hooks/useUser'
import { StepReturnQuality } from './StepReturnQuality'
import { RelatedAsnInfoDto } from './types'
import { RelatedAsnSelector } from './components/RelatedAsnSelector'
import { BlogStep } from '../../enums/eBlogStep'

interface ReturnsCreateReturnProps {
  onSearch: (searchParameters: any) => void
  handleSnackbar: (msg: string | undefined, status: boolean) => void
  handleModal: () => void
  setTitleModalBlog: React.Dispatch<React.SetStateAction<string | undefined>>
  setIsEditing?: (value: boolean) => void
}

export const getTitleByStep = (step: BlogStep): string => {
  switch (step) {
    case BlogStep.NuevaInversa:
      return 'Nueva devolución'
    case BlogStep.Buscar:
      return 'Buscar pedido'
    case BlogStep.Seleccionar:
      return 'Seleccionar'
    case BlogStep.SeleccionDevolucion:
      return 'Selección Devolución'
    case BlogStep.SeleccionLoteCreacionAsn:
      return 'Selección de Información y Creación Asn'
    case BlogStep.Calidad:
      return 'Control de Calidad'
    default:
      return ''
  }
}

export interface HeaderData {
  dispatchedDate: string
  courier: string
  courierCode: string
  workOrderId: number
  externalOrderId: string[]
  skuQuantity: number
  totalUnits: number
}

export const ReturnsCreateReturn: React.FC<ReturnsCreateReturnProps> = ({
  handleSnackbar,
  handleModal,
  setTitleModalBlog,
  setIsEditing
}) => {
  const [step, setStep] = useState(0)
  const [selectedTypeAsnIncomeId, setSelectedTypeAsnIncomeId] =
    useState<number>(-1)
  const [selectedWarehouseId, setSelectedWarehouseId] = useState<number>(-1)
  const [selectedAsnReturnDto, setSelectedAsnReturnDto] = useState<
    AsnReturnDto | undefined
  >() // guarda los datos de la fila seleccionada (en SearchReturn) de la pre Asn ya creada para mandar a formulario de seleccion de Lote (ReturnBatchSelecion)
  const [selectedOrderId, setSelectedOrderId] = useState<number>(0)
  const [selectedPreinboundId, setSelectedPreinboundId] = useState<number>(0)
  const [selectedAsnId, setSelectedAsnId] = useState<number>(0)
  const [selectedAsnStateId, setselectedAsnStateId] = useState<number>(0)
  const [selectedAsnNumber, setSelectedAsnNumber] = useState('')
  const [selectedTrackingNumber, setselectedTrackingNumber] = useState('')
  const [selectedCourier, setSelectedCourier] = useState('')
  const [selectedRelatedAsns, setSelectedRelatedAsns] = useState<
    RelatedAsnInfoDto[]
  >([])

  const [newPreInbound, setNewPreInbound] = useState(true) // variable para identificar si seleciono una pre asn ya creada y debe saltar al formulario de seleccion de Lote.
  const [returnOtHeader, setReturnOtHeader] = useState<HeaderData | undefined>(
    undefined
  )
  const { state, callApi, setIdle } = useApi<ReturnWorkOrderResponse[]>()
  const [items, setItems] = React.useState<WorkOrderItems[] | undefined>(
    undefined
  )
  const [itemsLoading, setItemsLoading] = useState(false)

  const {
    getUserData,
    userDataState: { userData }
  } = useUser()

  const {
    getCouriers,
    couriersState: { couriers }
  } = useCourier()

  const [selectedOT, setSelectedOT] = useState<
    | {
        workOrderId: number
        orderId: number | undefined
      }
    | undefined
  >(undefined)

  const handleSelectedOT = async (workOrderId: number, orderId?: number) => {
    const auxOrderId = state.data?.filter(
      (el) => el.workOrderId === workOrderId
    )[0]?.orderId

    // Creamos una promesa para resolver cuando setSelectedOT termine
    const setSelectedOTPromise = new Promise<void>((resolve) => {
      setSelectedOT({ workOrderId, orderId: orderId || auxOrderId })
      resolve()
    })

    // Esperamos a que la promesa se resuelva (es decir, que setSelectedOT haya terminado)
    await setSelectedOTPromise
  }

  const handleClearSelectedOT = () => {
    setSelectedOT(undefined)
  }

  useEffect(() => {
    if (selectedOT && state.data) {
      const elements = state.data.filter(
        (el) => el.workOrderId === selectedOT.workOrderId
      )

      setReturnOtHeader({
        workOrderId: elements[0].workOrderId,
        courier: elements[0].courier,
        courierCode: elements[0].courierCode,
        externalOrderId: elements.map(({ externalOrderId }) => externalOrderId),
        dispatchedDate: elements[0].dispatchedDate,
        skuQuantity: elements[0].skuQuantity,
        totalUnits: elements[0].totalUnits
      })
    }
  }, [selectedOT])

  useEffect(() => {
    if (couriers?.length === 0) {
      getCouriers()
    }

    if (!userData) {
      getUserData()
    }
  }, [])

  useEffect(() => {
    setTitleModalBlog(getTitleByStep(step))
  }, [step])

    // En caso de selección de motivos y lote se abre ventana de confirmación
  useEffect(() => {
    if (setIsEditing) {
      if (step === BlogStep.SeleccionDevolucion || step === BlogStep.SeleccionLoteCreacionAsn) {
        setIsEditing(true)
      } else {
        setIsEditing(false)
      }
    }
  }, [step, setIsEditing])

  return (
    <Grid container spacing={2}>
      {returnOtHeader && step > BlogStep.Buscar && step < BlogStep.Calidad && !itemsLoading && (
        <Grid size={{ xs: 12 }}>
          <CreateReturnHeader headerData={returnOtHeader} />
        </Grid>
      )}

      {/* FORMULARIO QUE MUESTRA GRILLA DE ASN LISTAS PARA CALIDAD Y PRE DEVOLUCIONES  */}
      {step === BlogStep.NuevaInversa && (
        <Grid size={{ xs: 12 }}>
          <SearchReturn
            setSelectedAsnReturnDto={setSelectedAsnReturnDto}
            setNewPreInbound={setNewPreInbound}
            setSelectedOrderId={setSelectedOrderId}
            setSelectedAsnId={setSelectedAsnId}
            setSelectedAsnNumber={setSelectedAsnNumber}
            setSelectedPreinboundId={setSelectedPreinboundId}
            setSelectedRelatedAsns={setSelectedRelatedAsns}
            handleStep={setStep}
            handleSnackbar={handleSnackbar}
          />
        </Grid>
      )}

      {/* FORMULARIO PARA BUSCAR OT DESPACHADA */}
      {step === BlogStep.Buscar && (
        <Grid size={{ xs: 12 }}>
          <SearchOrder
            setSelectedOrderId={setSelectedOrderId}
            setNewPreInbound={setNewPreInbound}
            selectedTypeAsnIncome={selectedTypeAsnIncomeId}
            setSelectedTypeAsnIncome={setSelectedTypeAsnIncomeId}
            setSelectedWarehouseId={setSelectedWarehouseId}
            handleSearchOrders={callApi}
            handleSelectedOT={handleSelectedOT}
            state={state}
            handleStep={setStep}
            handleSnackbar={handleSnackbar}
            setIdle={setIdle}
          />
        </Grid>
      )}

      {step === BlogStep.Seleccionar && state.data !== undefined && (
        <Grid size={{ xs: 12 }}>
          <MultipleReturns
            data={state.data}
            setSelectedWorkOrder={(id: number) => {
              handleSelectedOT(id)
              setStep(3)
            }}
            handleStep={setStep}
          />
        </Grid>
      )}

      {/* CREACIÓN DE PRE ASN. SELECCION DE COURIER Y TRACKING NUMBER  */}
      {step === BlogStep.SeleccionDevolucion && selectedOT !== undefined && (
        <Grid size={{ xs: 12 }}>
          <ReturnItemsSelection
            workOrderId={selectedOT.workOrderId}
            orderId={selectedOT.orderId}
            setStep={setStep}
            items={items}
            setItems={setItems}
            setIdle={setIdle}
            onLoadingChange={setItemsLoading}
            handleClearSelectedOT={handleClearSelectedOT}
            selectedTypeAsnIncome={selectedTypeAsnIncomeId}
            setPreinBoundId={setSelectedPreinboundId}
            setSelectedTrackingNumber={setselectedTrackingNumber}
            setSelectedCourier={setSelectedCourier}
            handleSnackbar={handleSnackbar}
          />
        </Grid>
      )}

      {/* SELECCION DE LOTE Y CREACIÓN DE ASN  */}
      {step === BlogStep.SeleccionLoteCreacionAsn && (
        <Grid size={{ xs: 12 }}>
          <ReturnBatchSelecion
            userId={userData?.userId || 0}
            selectedAsnReturnDto={selectedAsnReturnDto}
            newPreInbound={newPreInbound}
            selectedOrderId={selectedOrderId || 0}
            handleStep={setStep}
            handleSnackbar={handleSnackbar}
            setSelectedAsnId={setSelectedAsnId} // cuando llega una preasn en este modulo se crea la asn y deja el Id creadoo para luego saltar al Step 5 calidad y preguntar si esta recepcionada. en caso que no pregunta para recepcionar.
            setSelectedAsnNumber={setSelectedAsnNumber}
            setselectedAsnStateId={setselectedAsnStateId}  // guarda para consultar si se debe recepcionar la Asn dependiendo si la Asn esta pendiente.
            setSelectedRelatedAsns={setSelectedRelatedAsns} // guarda las Asn hijas (INT/EXT) cuando la devolución es de marca mixta
            selectedWarehouseId={selectedWarehouseId}
            selectedTypeAsnIncomeId={selectedTypeAsnIncomeId}
            selectedPreInboundId={selectedPreinboundId}
            selectedTrackingNumber={selectedTrackingNumber}
            selectedCourier={selectedCourier}
          />
        </Grid>
      )}

      {/* FORMULARIO CALIDAD  */}
      {step === BlogStep.Calidad && (
        <Grid size={{ xs: 12 }}>
          {/* Devolución de marca mixta: permite alternar entre las Asn hijas para controlar cada una */}
          <RelatedAsnSelector
            relatedAsns={selectedRelatedAsns}
            activeAsnId={selectedAsnId}
            onSelectAsn={(asn) => {
              setSelectedAsnId(asn.asnId)
              setSelectedAsnNumber(asn.asnNumber)
              setselectedAsnStateId(asn.asnStateId)
            }}
          />          
          <StepReturnQuality
            key={selectedAsnId}
            handleCloseModal={handleModal}
            userId={userData?.userId || 0}
            handleStep={setStep}
            handleSnackbar={handleSnackbar}
            selectedAsnStateId={
              // Valida la existencia de ASN relacionadas
              selectedRelatedAsns.length > 0
                ? selectedAsnStateId
                : selectedAsnReturnDto?.asnStateId || selectedAsnStateId
            }
            asnId={selectedAsnId}
            asnNumber={selectedAsnNumber}
          />
        </Grid>
      )}
      {state.status === Status.Loading && (
        <Grid size={{ xs: 12 }}>
          <Loading />
        </Grid>
      )}
      {step !== BlogStep.SeleccionDevolucion && (
        <Grid size={{ xs: 12 }}>
          <Box display='flex' justifyContent='flex-end'>
            <Button variant='outlined' onClick={handleModal}>
              Cerrar
            </Button>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}
